'use strict';

import $ from 'jquery';


export default class ShareLink {
  constructor(el) {
    this.el = el;
    this.$el = $(el);
    this.initialize();
  }

  initialize() {
    this.$el.on('click', this.share.bind(this));
  }

  share(e) {
    // Stop the link from opening, we will specify the popup below
    e.preventDefault();

    var $target = $(e.currentTarget);
    var href = $target.attr('href');

    // Open the share dialog
    window.open(
      href,
      'share',
      'height=560, width=640, toolbar=no, menubar=no, location=no, directories=no, status=no'
    );
  }
}


export function create($parent) {
  $parent.find('.Share-link').each((n, el) => new ShareLink(el));
}



// WEBPACK FOOTER //
// ./assets/components/ShareLink/ShareLink.js